import { FilterSortBy } from '../types';

export const sortByTranslations: Record<FilterSortBy, string> = {
  [FilterSortBy.ResultsCount]: 'Results Count',
  [FilterSortBy.AlphabeticalAscending]: 'A to Z',
  [FilterSortBy.AlphabeticalDescending]: 'Z to A',
  [FilterSortBy.CustomOrder]: 'Custom Arrangement',
};
